export default "__VITE_ASSET__tFzMGcdr__"